import React, { useState } from 'react';
import { GreenCheckBox } from '../../../components/greenCheckboxes/greenCheckBox';
import { RadioButtons } from 'components/inputBox/inputBox';
import './holidaySelection.scss';

interface IHolidaySelectionProps {
  primaryLabel: string;
  secondaryLabel?: string;
  ternaryLabel?: string;
  ternaryUnits?: string;
  title?: string;
  selection?: boolean;
}

const HolidaySelection = ({
  primaryLabel,
  secondaryLabel,
  ternaryLabel,
  ternaryUnits,
  selection = false,
  title = '쥬휴수당 선택',
}: IHolidaySelectionProps) => {
  const name = String(Math.floor(Math.random() * 1000));
  const [active, setActive] = useState<boolean>(selection);
  const [customValue, setCustomValue] = useState<string>('');

  return (
    <div className="holidaySelection">
      <div className="title">{title}</div>
      <div className="optionContainer">
        <div className="baseOptions">
          <GreenCheckBox
            onCheck={(value: boolean) => {
              setActive(value);
            }}
            rounded={true}
            defaultValue={active}
            text={primaryLabel}
          />
        </div>
        <div className="secondaryOptions" style={{ opacity: active && secondaryLabel?.length ? '100' : '0' }}>
          <input type="radio" value="Male" name={name} />
          <div className="optionLabel">{secondaryLabel}</div>
        </div>
        <div className="ternaryOptions" style={{ opacity: active && ternaryLabel?.length ? '100' : '0' }}>
          <input type="radio" value="Female" name={name} />
          <div className="optionLabel">{ternaryLabel}</div>
          <div className="customInputWrapper">
            <input
              className="customInput1"
              value={customValue}
              onChange={(e) => {
                setCustomValue(e.target.value);
              }}
            />
            <div className="unit">{ternaryUnits}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidaySelection;
